<div class="outerContainer">
    <i class="far fa-exclamation-triangle errorIcon"></i>
    <span class="errorMessage">{{message}}</span>
</div>
